module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Router2-edcd5224081c813dfe30f4bf570cc400.svg";